import type { Pricing } from '@bulknutrients/bulk-shared-lib/interfaces/Product';
import type { ReactElement } from 'react';

export function ProductPrice({
  basePrice,
  price,
}: {
  basePrice: number;
  price: number;
}): ReactElement {
  const [dollarPrice, centsPrice] = price.toFixed(2).split('.');

  if (basePrice === price) {
    return (
      <span className="text-2xl font-bold text-black inline-flex items-start dark:text-white">
        $<span className="text-4xl">{dollarPrice}</span>.{centsPrice}
      </span>
    );
  }
  return (
    <div className="flex flex-col mb-2">
      <span className="flex gap-1">
        <span>Usual price</span>
        <span className="relative text-base before:absolute before:left-[-5%] before:top-[45%] before:mx-auto before:my-0 before:w-[110%] before:skew-y-[-10deg] before:border-0 before:border-t-2 before:border-solid before:border-t-orange before:opacity-60 before:content-['']">
          ${basePrice.toFixed(2)}
        </span>
      </span>
      <span className="price font-bold text-black inline-flex items-start dark:text-white my-2 text-2xl">
        $<span className="text-4xl">{dollarPrice}</span>.{centsPrice}
      </span>
      <span className="font-primary text-base italic">
        You save ${(basePrice - price).toFixed(2)}
      </span>
    </div>
  );
}

export function ProductPriceRange({
  minPrice,
  maxPrice,
}: {
  minPrice: number;
  maxPrice: number;
}): ReactElement {
  const [minDollar, minCents] = minPrice.toFixed(2).split('.');
  const [maxDollar, maxCents] = maxPrice.toFixed(2).split('.');

  return (
    <div className="font-bold text-black dark:text-white text-2xl">
      <span className="mx-1 my-0 inline-flex items-start">
        $<span className="text-4xl">{minDollar}</span>.{minCents}{' '}
      </span>
      -
      <span className="mx-1 my-0 inline-flex items-start">
        $<span className="text-4xl">{maxDollar}</span>.{maxCents}
      </span>
    </div>
  );
}

export function ProductPricing({
  pricing,
}: {
  pricing: Pricing;
}): ReactElement {
  return pricing.priceRange.min.value === pricing.priceRange.max.value ? (
    <ProductPrice
      basePrice={
        pricing.basePrice ? pricing.basePrice.value : pricing.price.value
      }
      price={pricing.price.value}
    />
  ) : (
    <ProductPriceRange
      minPrice={pricing.priceRange.min.value}
      maxPrice={pricing.priceRange.max.value}
    />
  );
}
